/**
 * Reset do estado de onboarding (welcome modal + tours).
 *
 * Lista canônica das keys que controlam first-time UX:
 *   - pakt_onboarded                    → welcome modal do Dashboard
 *   - pakt_tour_first_doc_dashboard     → tour passo 1 (botão Novo doc)
 *   - pakt_tour_first_doc_newdoc        → tour passo 2 (upload + signers)
 *   - pakt_tour_first_doc_status        → tour passo 3 (status + verify)
 *
 * Adicionar tour novo? Inclua a key aqui pra que o "Rever boas-vindas"
 * limpe corretamente.
 */
export const ONBOARDING_KEYS = [
  'pakt_onboarded',
  'pakt_tour_first_doc_dashboard',
  'pakt_tour_first_doc_newdoc',
  'pakt_tour_first_doc_status',
] as const

/** Apaga todas as keys de onboarding do localStorage. */
export function resetOnboarding(): void {
  for (const key of ONBOARDING_KEYS) {
    localStorage.removeItem(key)
  }
}

/** Verifica se o user já completou pelo menos UM passo de onboarding. */
export function hasAnyOnboardingProgress(): boolean {
  return ONBOARDING_KEYS.some(k => !!localStorage.getItem(k))
}
